import axios from "axios";
import { keyAccessToken, keyUserId } from "../../../../../../assets/js/SessionStorageNames";
import { useContext } from "react";
import { GlobalContext } from "../../../../../../contexts/GlobalContext";


const useCasheaCampaign = () => {    
    const globalContext = useContext(GlobalContext);

    const sendCampaign = async (enterpriseId, pricelistId, plusPercent, dateFrom, dateTo, nameCampaign, excelFile = null, pricelistName = '') => {

        try {
            globalContext.setLoaderPage(false);
            globalContext.showModalWithMsg(`Creando campaña, puede visualizar su estatus en la vista de segundo plano`);
    
            const headers = {
                "x-api-key": process.env.REACT_APP_API_KEY,
                "x-access-token": localStorage.getItem(keyAccessToken),
                "x-user-id": localStorage.getItem(keyUserId),
            };
            const url = excelFile
                ? `${process.env.REACT_APP_BACKEND_URL}/v1/cashea-campaign/send-from-excel-pricelist`
                : `${process.env.REACT_APP_BACKEND_URL}/v1/cashea-campaign/send-from-odoo-pricelist`;
            const payload = excelFile
                ? (() => {
                    const formData = new FormData();
                    formData.append('xlsx', excelFile);
                    formData.append('pricelistId', pricelistId);
                    formData.append('pricelistName', pricelistName);
                    formData.append('plusPercent', plusPercent);
                    formData.append('enterpriseId', enterpriseId);
                    formData.append('dateFrom', dateFrom);
                    formData.append('dateTo', dateTo);
                    formData.append('nameCampaign', nameCampaign);
                    return formData;
                })()
                : { pricelistId, plusPercent, enterpriseId, dateFrom, dateTo, nameCampaign };

            const res = await axios.post(url, payload, { headers });
    
            return res;
    
        } catch (err) {
            globalContext.setLoaderPage(false);
            console.error(err);
            const errorMessage =
                err?.response?.data?.message ||
                err?.message ||
                "Ocurrió un error al crear la campaña";

            globalContext.showModalWithMsg(errorMessage);
            throw new Error(errorMessage);
        }
    }


    const deleteProductsCampaign = async (enterpriseId, campaignId, pricelistId) => {

        try {
            globalContext.setLoaderPage(false);
            globalContext.showModalWithMsg(`Eliminado campaña, puede visualizar su estatus en la vista de segundo plano`);
    
            const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/v1/cashea-campaign/delete-from-campign-id`,
                {
                    campaignId,
                    enterpriseId,
                    pricelistId,
                }, {
                headers: {
                    "x-api-key": process.env.REACT_APP_API_KEY,
                    "x-access-token": localStorage.getItem(keyAccessToken),
                    "x-user-id": localStorage.getItem(keyUserId),
                },
            })

            console.log(`res: ${res}`);
            console.log(`res: ${JSON.stringify(res)}`);
    
            return res;
    
        } catch (err) {
            globalContext.setLoaderPage(false);
            console.error(err);
            globalContext.showModalWithMsg(
                `Ocurrió un error al eliminar la campaña ${err}. Por favor presiona el boton de actualizar`
            );
        }
    }

    
    return {sendCampaign, deleteProductsCampaign};
};

export default useCasheaCampaign;